import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';

import { ILead } from '../../interfaces/ILead';
import api from '../../services/api';

const getLead = (gid: string | number): Promise<{ lead: ILead }> => api.get(`/api/frontend/leads/${gid}`);

const LEAD_QUERY_KEY = 'lead_by_gid';

export const leadQueryOptions = (gid: string | number | undefined) =>
  queryOptions({
    queryKey: [LEAD_QUERY_KEY, gid],
    queryFn: gid ? () => getLead(gid) : skipToken,
    select: data => data.lead
  });
const useLead = (gid: string | number | undefined) => useQuery(leadQueryOptions(gid));

export default useLead;
